import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import GetAppIcon from '@mui/icons-material/GetApp';

import UserService from "services/UserService";
import axios from "axios";
import { getSchedules } from "services/ConfigServices";
import { scheduletext } from "variables/MBM/schedule";
import { typeData } from "variables/MBM/lists/schedule";
import moment from "moment";
import CustomSelect from "components/Input/CustomSelect.js";
import { downloadCSV } from "utilities/exporttabletocsv";
import Button from "components/CustomButtons/Button.js";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import AddSchedule from "./AddSchedule";
import { NotificationManager } from "react-notifications";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

const FilterDiv = styled.div`
  margin-right: auto;
  margin-top: -8px;
`;


export default function useSchedulesTable(wpgroup, equipmentsdata, pointsdata) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_geb_control_schedules = permis.includes("mbm_geb_control_schedules");
  const appContext = useContext(AdvancedSearchContext);
  const { groupInfoListById } = appContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getSchedules(wpgroup);
  const [results, setResults] = useState({ meters: [] });
  const [loading, setLoading] = useState(false);
  const [selectedSchedules, setSelectedSchedules] = useState([]);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (wpgroup && wpgroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === wpgroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = wpgroup;
      fetchData();
    }
  }, [wpgroup, refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = _.get(results, `schedules`, []).filter(
    (item) =>
      (item.parameters?.name && item.parameters?.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters?.authorname && item.parameters?.authorname.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters?.modifiername && item.parameters?.modifiername.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.groupid && groupInfoListById["" + item.groupid] && groupInfoListById["" + item.groupid].toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters?.type && typeData.find((x) => x.id == item.parameters?.type) && typeData.find((x) => x.id == item.parameters?.type).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters?.lastupdate && moment(item.parameters?.lastupdate).isValid() && moment(item.parameters?.lastupdate).format("DD/MM/YYYY HH:mm").includes(filterText))
  )
    ;

  const setNotification = (status, text) => {
    if (status === 'success') {
      NotificationManager.success(text);
    }
    else {
      NotificationManager.error(text);
    }
  };

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = selectedSchedules.map((item) => {
      let scheduletoexport = {};
      scheduletoexport[scheduletext.id] = item.id;
      scheduletoexport[scheduletext.name] = item.parameters?.name;
      scheduletoexport[scheduletext.type] = typeData.find((x) => x.id == item.parameters?.type)?.name;
      scheduletoexport[scheduletext.author] = item.parameters?.authorname;
      scheduletoexport[scheduletext.modifier] = item.parameters?.modifiername;
      scheduletoexport[scheduletext.lastupdate] = item.parameters?.lastupdate && moment(item.parameters?.lastupdate).isValid() ? moment(item.parameters?.lastupdate).format("DD/MM/YYYY HH:mm") : "";
      scheduletoexport[scheduletext.group] = groupInfoListById["" + item.groupid];
      return scheduletoexport;
    });

    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {mbm_geb_control_schedules && (
          <>
            <UploadButton type="button" onClick={handleClear}>
              <AddSchedule
                refetch={refreshTable}
                onClick={handleClear}
                setLoading={setLoading}
                setNotification={setNotification}
                wpgroup={wpgroup}
                equipmentsdata={equipmentsdata}
                pointsdata={pointsdata}
              />
            </UploadButton>
          </>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!selectedSchedules || selectedSchedules.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, selectedSchedules, results, equipmentsdata, pointsdata]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setSelectedSchedules,
    setLoading,
  };
}
